import React, { useContext, useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import GlobalStyle from '../styles/GlobalStyle';
import '../fonts/fonts.css';
import { Wrapper } from './ui';
import Header from './Header';
import Cart from './Cart';
import NewsletterSignup from './NewsletterSignup';
import SaleNotice from './SaleNotice';
import Footer from './Footer';
import BackToTop from './BackToTop';
import { StoreContext } from '../context/StoreContext';

const Layout = ({
  seo,
  noIndex,
  currentProductId,
  cartCrossSellProducts,
  children,
}) => {
  const {
    datoCmsSite: { faviconMetaTags },
  } = useStaticQuery(graphql`
    query LayoutQuery {
      datoCmsSite {
        faviconMetaTags {
          ...GatsbyDatoCmsFaviconMetaTags
        }
      }
    }
  `);

  const { isOverlayActive, setOverlayActive, isCartOpen, toggleCartOpen } =
    useContext(StoreContext);

  useEffect(() => {
    setOverlayActive(isCartOpen);
  }, [setOverlayActive, isCartOpen]);

  return (
    <>
      <HelmetDatoCms seo={seo} favicon={faviconMetaTags}>
        <html lang="en-GB" />
        {noIndex && <meta name="robots" content="noindex, follow" />}
      </HelmetDatoCms>
      <GlobalStyle />
      <Wrapper
        isOverlayActive={isOverlayActive}
        onClick={e => {
          if (e.target === e.currentTarget) {
            if (isCartOpen) {
              toggleCartOpen();
            }
          }
        }}
      >
        <Header />
        {children}
        <Cart
          currentProductId={currentProductId}
          crossSellProducts={cartCrossSellProducts}
        />
        <NewsletterSignup />
        <SaleNotice />
        <Footer />
        <BackToTop />
      </Wrapper>
    </>
  );
};

export default Layout;
